<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="待使用(0)" name="first">
          <gift-card-order-single v-if="activeName == 'first'" :tabCurrent="0"></gift-card-order-single>
        </el-tab-pane>
        <el-tab-pane label="已使用" name="second">
          <gift-card-order-single v-if="activeName == 'second'" :tabCurrent="1"></gift-card-order-single>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import GiftCardOrderSingle from './components/GiftCardOrderSingle.vue'
export default {
  name: 'GiftCardOrder',
  components: {
    GiftCardOrderSingle
  },
  data () {
    return {
      imgServer: this.$imgServer,
      fullscreenLoading: false,
      activeName: 'first',
      activeNum:1
    }
  },
  mounted () {

  },
  methods: {
    handleClick () {

    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/giftCard/GiftCardOrder.vue